import { useState, useEffect, useContext, useRef } from "react";
import { usePlatforms } from "../../../../hooks/usePlatforms";
import "./index.css";

import Spinner from "../../../../components/Spinner";
import PageContainer from "../../../../components/layout/PageContainer";
import PlatformDetailsHeader from "./components/PlatformDetailsHeader";
import Input from "../../../../components/common/Input";
import Textarea from "../../../../components/common/Textarea";
import {
  getFormatDate,
  translate,
} from "../../../../utils/Common";
import { useForm, Controller, FormProvider } from "react-hook-form";
import ModalContext from "../../../../contexts/modal";
import { FaHistory, FaSignal, FaArrowLeft } from "react-icons/fa";
import { FiInfo, FiMapPin } from "react-icons/fi";
import * as GiIcons from "react-icons/gi";
import ContentCard from "../../../../components/layout/ContentCard";
import Badge from "../../../../components/common/Badge";
import SmartLocker from "../SmartLocker";
import styles from "./PlatformDetailsForm.module.css";
import ShowTable from "../../../../components/ShowTable";
import ItemDoorPlatforms from "../../../../components/ShowTable/ItemDoorPlatforms";
import { useLocation } from "react-router-dom";
import { configRolesUsers, findActionsByPathWithFallback } from "../../../../config/permissions";
import { LuAlertCircle } from "react-icons/lu";
import ignoreAbort from '../../../../utils/ignoreAbort';

const PlatformDetails = ({
  setPlatformSelected,
  platformSelected,
  onRefresh,
  onBack,
}) => {
  const { updateDetails, getPlatformDetails, rebootLocation } = usePlatforms();
  const [platformDetails, setPlatformDetails] = useState(null);
  const methods = useForm({
    defaultValues: {
      nombre: '',
      ip: '',
      direccionfisica: '',
      latlng: '',
      linkubicacion: '',
      refExtern: '',
      refIntern: '',
    },
  });
  const { control, handleSubmit, clearErrors, formState: { errors }, reset } = methods;
  const modalContext = useContext(ModalContext);
  const refMovementDoors = useRef(null);
  const movementsAnchorRef = useRef(null);

  const statusLog =
    (platformSelected.IdEstatus || platformSelected.statusId) === 1
      ? true
      : false;

  const [active, setActive] = useState(statusLog);

  const [editActive, setEditActive] = useState(false);
  const [filterMovementSelect, setFilterMovementSelect] = useState(null);
  const [actionsPerms, setActionsPerms] = useState([]);
  
  const location = useLocation();

  const [listMovements, setListMovements] = useState(null);
  const [headerRow] = useState(
    <tr>
      <th>ID {translate("global.movement")}</th>
      <th>{translate("global.movementType")}</th>
      <th>{translate("dashboard.packages.details.numPackage")}</th>
      <th>{translate("dashboard.packages.details.numTracking")}</th>
      <th>{translate("global.movementDate")}</th>
      <th>{translate("global.currentStatusPackage")}</th>
    </tr>
  );

  const handleEditToggle = () => {
    if (!editActive) {
      setEditActive(true);
    } else {
      const data = {
        nombre: platformDetails?.Nombre || '',
        ip: platformDetails?.IP || '',
        direccionfisica: platformDetails?.Direccion_Fisica || '',
        latlng: platformDetails?.LatLng || '',
        linkubicacion: platformDetails?.LinkUbicacion || '',
        refExtern: platformDetails?.ReferenciaExterna || '',
        refIntern: platformDetails?.ReferenciaInterna || ''
      };
      reset(data);
      setActive(platformDetails?.IdEstatus === 1);
      setEditActive(false);
    }
  };

  const handleUpdate = async (data) => {
    
    try {

        modalContext.setIsOpenModal(false);
        clearErrors();
        let dataToSend = {
          idPlataforma: platformDetails.IdPlataforma,
          IdEstatus: active ? 1 : 0
        };

        if (data.nombre.toUpperCase() !== (platformDetails.Nombre ? platformDetails.Nombre.toUpperCase() : ""))
          dataToSend.nombre = data.nombre;
        else dataToSend.nombre = platformDetails.Nombre;
        
        if (data.ip.toUpperCase() !== (platformDetails.IP ? platformDetails.IP.toUpperCase() : ""))
          dataToSend.ip = data.ip;
        else dataToSend.ip = platformDetails.IP;
        
        if (data.direccionfisica.toUpperCase() !== (platformDetails.Direccion_Fisica ? platformDetails.Direccion_Fisica.toUpperCase() : ""))
          dataToSend.direccionfisica = data.direccionfisica;
        else dataToSend.direccionfisica = platformDetails.Direccion_Fisica;
        
        if (data.latlng.toUpperCase() !== (platformDetails.LatLng ? platformDetails.LatLng.toUpperCase() : ""))
          dataToSend.latlng = data.latlng;
        else dataToSend.latlng = platformDetails.LatLng;
        
        if (data.linkubicacion.toUpperCase() !== (platformDetails.LinkUbicacion ? platformDetails.LinkUbicacion.toUpperCase() : ""))
          dataToSend.linkubicacion = data.linkubicacion;
        else dataToSend.linkubicacion = platformDetails.LinkUbicacion;
        
        if (data.refExtern.toUpperCase() !== (platformDetails.ReferenciaExterna ? platformDetails.ReferenciaExterna.toUpperCase() : ""))
          dataToSend.ReferenciaExterna = data.refExtern;
        else dataToSend.ReferenciaExterna = platformDetails.ReferenciaExterna;
        
        if (data.refIntern.toUpperCase() !== (platformDetails.ReferenciaInterna ? platformDetails.ReferenciaInterna.toUpperCase() : ""))
          dataToSend.ReferenciaInterna = data.refIntern;
        else dataToSend.ReferenciaInterna = platformDetails.ReferenciaInterna;

        const updateResult = await updateDetails(dataToSend);
        
        if (updateResult.message === "UPDATED_SUCCESS") {
          modalContext.confirm(
            translate("global.alerts.successTransact"),
            translate("dashboard.platforms.details.success"),
            <button
              type="reset"
              key={2}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground"
              onClick={() => modalContext.setIsOpenModal(false)}
            >
              {translate("global.accept")}
            </button>,
            true
          );
          onRefresh();
          setEditActive(!editActive);
        } else {
          modalContext.confirm(
            translate("global.alerts.ops"),
            <span>{translate("dashboard.platforms.create.alert.error")}</span>,
            <button
              type="button"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
              onClick={() => modalContext.setIsOpenModal(false)}
            >
              {translate("global.accept")}
            </button>,
            true
          );
        }
    
    } catch (error) {
      
      modalContext.confirm(
        translate("global.alerts.ops"),
        <span>{translate("dashboard.platforms.create.alert.error")}</span>,
        <button
          type="button"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
          onClick={() => modalContext.setIsOpenModal(false)}
        >
          {translate("global.accept")}
        </button>,
        true
      );
    }
  };

  const handleResetLocker = async () => {
    
    modalContext.confirm(
      translate("global.continue") + "?",
      translate("global.question.continueResetLocker"),
      [
        <button
          type="button"
          key={1}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
          disabled
        >
          <Spinner type={1} size={20} />
        </button>,
        <button
          key={2}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground"
          disabled
        >
          {translate("global.cancel")}
        </button>,
      ],
      true
    );
    
    const platform = platformSelected.boxitLocationId;
    const response = await rebootLocation({ platformId: platform });

    if (response.code === 200) {
      modalContext.confirm(
        translate("global.alerts.successTransact"),
        translate("global.successResetLocker"),
        <button
          type="reset"
          key={2}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground"
          onClick={() => modalContext.setIsOpenModal(false)}
        >
          {translate("global.accept")}
        </button>,
        true
      );
      onRefresh();
    } else if(response.message === "INSTRUCTION_NO_SENT_WAIT_10_MINUTES") {
      modalContext.confirm(
        translate("global.alerts.ops"),
        <span>{translate("dashboard.platforms.create.alert.error10minutes")}</span>,
        <button
          type="button"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
          onClick={() => modalContext.setIsOpenModal(false)}
        >
          {translate("global.accept")}
        </button>,
        true
      );
    } else {
      modalContext.confirm(
        translate("global.alerts.ops"),
        <span>{translate("dashboard.platforms.create.alert.error")}</span>,
        <button
          type="button"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
          onClick={() => modalContext.setIsOpenModal(false)}
        >
          {translate("global.accept")}
        </button>,
        true
      );
    }
  }

  // Salir del detalle es siempre volver al listado de plataformas. Quien sabe
  // limpiar también la query string del deep link es la vista de lockers, así que
  // el handler viene de ella; sin él queda el comportamiento de siempre.
  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    setPlatformSelected(null);
    onRefresh();
  };

  const handleConfirm = (data) => {
    modalContext.confirm(
      translate("global.continue") + "?",
      translate("global.question.continueChanges"),
      [
        <button
          type="button"
          key={1}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
          onClick={() => handleUpdate(data)}
        >
          {translate("global.accept")}
        </button>,
        <button
          type="reset"
          key={2}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground"
          onClick={() => modalContext.setIsOpenModal(false)}
        >
          {translate("global.cancel")}
        </button>,
      ],
      true
    );
  };

  const setPermsActions = () => {
    const path = `${location.pathname}${location.search || ""}`;
    let user;
    try {
      user = JSON.parse(sessionStorage.getItem("user"));
    } catch {
      user = null;
    }
    const data = configRolesUsers[user?.roleId];
    const actions = findActionsByPathWithFallback(data, path);
    setActionsPerms(actions);
  }

  useEffect(() => {
    const abortController = new AbortController();
    const handlePlatform = async () => {
      const response = await getPlatformDetails(
        platformSelected.boxitLocationId,
        abortController.signal
      );
      setPlatformDetails(response);
      setActive(response?.IdEstatus === 1);
      const data = {
        nombre: response?.Nombre || '',
        ip: response?.IP || '',
        direccionfisica: response?.Direccion_Fisica || '',
        latlng: response?.LatLng || '',
        linkubicacion: response?.LinkUbicacion || '',
        refExtern: response?.ReferenciaExterna || '',
        refIntern: response?.ReferenciaInterna || ''
      };
      reset(data);
    };
    handlePlatform().catch(ignoreAbort);
    setPermsActions();
    return () => abortController.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- carga por boxitLocationId; evitar re-fetches en bucle
  }, [platformSelected.boxitLocationId, reset]);

  const handleFocusMovements = () => {
    // El input existe solo cuando `listMovements` tiene items, así que usamos un ancla
    // que siempre está en el DOM para garantizar el scroll.
    requestAnimationFrame(() => {
      movementsAnchorRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      // Cuando ya renderice el card, intenta enfocar el input (opcional).
      // Usamos timeout corto para evitar carreras con el render condicional.
      setTimeout(() => {
        refMovementDoors.current?.focus?.();
      }, 150);
    });
  };

  const handleRestartButtonClick = () => {

    modalContext.confirm(
      translate("global.continue") + "?",
      translate("global.question.continueResetLocker"),
      [
        <button
          type="button"
          key={1}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
          onClick={() => handleResetLocker()}
        >
          {translate("global.accept")}
        </button>,
        <button
          type="reset"
          key={2}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground"
          onClick={() => modalContext.setIsOpenModal(false)}
        >
          {translate("global.cancel")}
        </button>,
      ],
      true
    );

  };

  return !platformDetails ? (
    <PageContainer>
      <div className="loader center">
        <Spinner type={0} size={40} />
      </div>
    </PageContainer>
  ) : (
    <PageContainer>
    {platformDetails?.Result === 1 ? (
       <div style={{ padding: "1rem" }}>
       <FormProvider {...methods}>
       <form
         className="package-info m-0 p-0 text-left text-sm"
         onSubmit={handleSubmit(handleConfirm)}
         id="platform-details-form"
       >
         <PlatformDetailsHeader
           platformSelected={platformSelected}
           platformDetails={platformDetails}
           editActive={editActive}
           control={control}
           errors={errors}
           handleEditToggle={handleEditToggle}
           onBack={handleBack}
           actionsPerms={actionsPerms}
           onResetLocker={handleRestartButtonClick}
         />
         <div className={styles.detailsGrid}>
           {/* Columna izquierda: Info general + Ubicación */}
           <div className={styles.leftColumn}>
             {/* Card 1: Información general */}
             <ContentCard
               title={
                 <div className={styles.cardTitle}>
                   <FiInfo size={20} />
                   <span>{translate("dashboard.platforms.details.generalInfo")}</span>
                 </div>
               }
               padding="md"
             >
               <div className={styles.infoList}>
                 <div className={styles.infoItem}>
                   <span className={styles.infoLabel}>{translate("global.name")}</span>
                   <span className={styles.infoValue}>
                     {platformDetails?.Nombre ?? platformSelected?.locationName ?? platformSelected?.Plataforma ?? "-"}
                   </span>
                 </div>
                 <div className={styles.infoItem}>
                   <span className={styles.infoLabel}>{translate("global.state")}</span>
                   <div className={styles.infoValue}>
                     <Badge
                       variant={platformSelected?.locationStatus === "ONLINE" ? "success" : "error"}
                       size="sm"
                       icon={
                         platformSelected?.locationStatus === "ONLINE" ? (
                           <FaSignal size={12} />
                         ) : (
                           <LuAlertCircle size={12} />
                         )
                       }
                     >
                       {platformSelected?.locationStatus === "ONLINE" ? "Online" : "Offline"}
                     </Badge>
                   </div>
                 </div>
                 <div className={styles.infoItem}>
                   <span className={styles.infoLabel}>{translate("global.type")}</span>
                   <span className={styles.infoValue}>{platformDetails?.Tipo || "LOCKER"}</span>
                 </div>
                 <div className={styles.infoItem}>
                   <span className={styles.infoLabel}>{translate("global.ExternalID")}</span>
                   <span className={styles.infoValue}>
                     {platformSelected?.locationId ?? platformDetails?.IdExterno ?? "-"}
                   </span>
                 </div>
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>{translate("dashboard.platforms.details.createDate")}</span>
                  <span className={styles.infoValue}>
                    {platformDetails?.FechaCreacion ? getFormatDate(platformDetails.FechaCreacion) : "-"}
                  </span>
                </div>
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>{translate("dashboard.platforms.details.licenseCode")}</span>
                  <span className={styles.infoValue}>
                    {platformDetails?.CodLicencia ?? "-"}
                  </span>
                </div>
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>{translate("dashboard.platforms.details.activationDate")}</span>
                  <span className={styles.infoValue}>
                    {platformDetails?.FechaActivacion ? getFormatDate(platformDetails.FechaActivacion) : "-"}
                  </span>
                </div>
              </div>
            </ContentCard>

             {/* Card 2: Ubicación y referencias */}
             <ContentCard
               title={
                 <div className={styles.cardTitle}>
                   <FiMapPin size={20} />
                   <span>{translate("dashboard.platforms.details.locationAndRefs")}</span>
                 </div>
               }
               padding="md"
             >
               <div className={styles.infoList}>
                 <div className={`${styles.infoItem} ${styles.infoItemFullWidth}`}>
                   <span className={styles.infoLabel}>{translate("global.address")}</span>
                   <div className={`${styles.infoValue} ${styles.infoValueFullWidth}`}>
                     <Controller
                       name="direccionfisica"
                       control={control}
                       rules={{ required: { value: true, message: translate("global.isRequerid") } }}
                       render={(field) => (
                         <Input
                           ref={field.ref}
                           name={field.name}
                           value={field.value ?? ''}
                           onChange={(e) => field.onChange(e.target.value)}
                           onBlur={field.onBlur}
                           error={errors.direccionfisica?.message}
                           disabled={!editActive}
                           fullWidth
                           size="sm"
                         />
                       )}
                     />
                   </div>
                 </div>
                 <div className={`${styles.infoItem} ${styles.infoItemFullWidth}`}>
                   <span className={styles.infoLabel}>{translate("global.coordinates")}</span>
                   <div className={`${styles.infoValue} ${styles.infoValueFullWidth}`}>
                     <Controller
                       name="latlng"
                       control={control}
                       render={(field) => (
                         <Input
                           ref={field.ref}
                           name={field.name}
                           value={field.value ?? ''}
                           onChange={(e) => field.onChange(e.target.value)}
                           onBlur={field.onBlur}
                           placeholder="ej: 9.0281749,-79.522551"
                           error={errors.latlng?.message}
                           disabled={!editActive}
                           fullWidth
                           size="sm"
                         />
                       )}
                     />
                   </div>
                 </div>
                <div className={`${styles.infoItem} ${styles.infoItemFullWidth}`}>
                  <span className={styles.infoLabel}>{translate("global.referenceIntern")}</span>
                   <div className={`${styles.infoValue} ${styles.infoValueFullWidth}`}>
                     <Controller
                       name="refIntern"
                       control={control}
                       render={(field) => (
                         <Textarea
                           {...field}
                           value={field.value ?? ''}
                           onChange={(e) => field.onChange(e.target.value)}
                           disabled={!editActive}
                           rows={2}
                           fullWidth
                         />
                       )}
                     />
                   </div>
                 </div>
                 <div className={`${styles.infoItem} ${styles.infoItemFullWidth}`}>
                   <span className={styles.infoLabel}>{translate("global.referenceExtern")}</span>
                   <div className={`${styles.infoValue} ${styles.infoValueFullWidth}`}>
                     <Controller
                       name="refExtern"
                       control={control}
                       render={(field) => (
                         <Textarea
                           ref={field.ref}
                           name={field.name}
                           value={field.value ?? ''}
                           onChange={(e) => field.onChange(e.target.value)}
                           onBlur={field.onBlur}
                           disabled={!editActive}
                           rows={2}
                           fullWidth
                         />
                       )}
                     />
                   </div>
                 </div>
               </div>
             </ContentCard>
           </div>

           {/* Columna derecha: Vista del locker */}
           <div className={styles.rightColumn}>
             <ContentCard
               title={
                 <div className={styles.cardTitle}>
                   <GiIcons.GiPlatform size={20} />
                   <span>{translate("dashboard.platforms.details.lockerView")}</span>
                 </div>
               }
               padding="none"
             >
               <SmartLocker
                 idPlatform={platformSelected.locationId}
                 idPlatformNumeric={platformSelected.boxitLocationId}
                 estatusPlatform={platformSelected.locationStatus}
                 setListMovements={setListMovements}
                 setFilterMovementSelect={setFilterMovementSelect}
                 handleFocusMovements={handleFocusMovements}
                 actionsPerms={actionsPerms}
               />
             </ContentCard>
           </div>

          {/* Sección movimientos - full width debajo */}
          <div ref={movementsAnchorRef} />
          {listMovements?.length > 0 && (
             <div className={styles.movementsSection}>
               <ContentCard padding="md">
                 <div className={styles.movementsHeader}>
                   <FaHistory size={20} />
                   <h3>{translate("global.movementsDoors")}</h3>
                 </div>
                 {filterMovementSelect && (
                   <div className={styles.movementsFilter}>
                     <Badge variant="primary" size="sm">
                       {translate("global.door")}: {filterMovementSelect?.numDoor}
                     </Badge>
                     <Badge variant="neutral" size="sm">
                       {translate("dashboard.accounting.from")}: {filterMovementSelect?.dateFrom}
                     </Badge>
                     <Badge variant="neutral" size="sm">
                       {translate("dashboard.accounting.to")}: {filterMovementSelect?.dateTo}
                     </Badge>
                   </div>
                 )}
                 <ShowTable
                   headerRow={headerRow}
                   itemArray={listMovements}
                   Item={(props) => <ItemDoorPlatforms {...props} />}
                   noItemsFound={translate("dashboard.delivery.table.noItemsFound")}
                   actualPage={1}
                   itemsShowing={listMovements?.length}
                 />
                 <input
                   type="text"
                   id="table-movements-doors"
                   ref={refMovementDoors}
                   style={{ opacity: "0" }}
                 />
               </ContentCard>
             </div>
           )}
         </div>
       </form>
       </FormProvider>
     </div>
           ) : (
             <div
               className="package-info p-6 flex justify-center items-center"
               style={{ fontSize: 14 }}
             >
               <button
                 className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground flex items-center mr-2"
                 type="button"
                 onClick={handleBack}
               >
                 <FaArrowLeft className="mr-2" /> {translate("global.return")}
               </button>
               <LuAlertCircle size={20} className="mr-2" />
               {translate("global.NOT_AVAILABLE")}
             </div>
           )
    }
    </PageContainer>
  );
};

export default PlatformDetails;
